export default {
      id: "arrow_down-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/icons.85006585.svg#arrow_down",
      toString: function () {
        return this.url;
      }
    }